import styled from "styled-components";

import variables from "../../styles/variables";

interface Props {
  disabled?: boolean;
}

// Wrapper on custom compare checkbox
export const CompareCheckWrapper = styled.div`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:hover div.customCheckbox {
    background: ${variables.colorRed};
    border: solid ${variables.colorRed} 2px;
  }
  &:active div.customCheckbox {
    background: ${variables.colorRed};
    border: solid ${variables.colorRed} 2px;
  }
`;

// Label on compare checkbox is clickable
export const CompareLabel = styled.label`
  color: ${({ disabled }: Props) => (disabled ? '#9C9C9C' : '#333333')};
  input {
    cursor: pointer;
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
  /* When the hidden input gets focus, add focus style to visible checkbox */
  input:focus ~ div.focusWrapper {
    outline: 5px auto Highlight;
    outline: 5px auto -webkit-focus-ring-color;
  }
  div.focusWrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

// Custom checkbox for styling
export const CheckBox = styled.div`
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  flex-basis: 15px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  border: solid ${variables.colorGreyMedium} 2px;
  &.checked {
    background: ${variables.colorRed};
    border: solid ${variables.colorRed} 2px;
  }
  /* The checkmark */
  img {
    width: 100%;
    height: 100%;
  }
`;

// Text next to checkbox
export const CompareText = styled.p`
  font-size: 12px;
  margin-bottom: 0;
  white-space: nowrap;
`;
